import { ApplicationFeature, DefaultApplicationFeatures } from "./Features";
import { Organization } from "./Organization";
import { Partner } from "./Partners";

export type Site =
{
    id: string,
    organizationId: string | null,
    settings: SiteSettings,
    loginName: string
}

export type SiteView =
{
    id: string,
    settings: SiteSettings,
    loginName: string,
    organization:Organization | null
}

export const 
SiteFlags = [ 'demo', 'undervisning', 'skal slettes' ] as const;
export type SiteFlag = typeof SiteFlags[number];

export type SiteSettings = {
    enabled: boolean,
    hideSurveyEmailAddresses: boolean,
    apiVideoKey: string,
    features: ApplicationFeature[],
    flags:SiteFlag[]
};

export function getDefaultSiteSettings (): SiteSettings
{    
    return {
        enabled: true,
        hideSurveyEmailAddresses: false,
        apiVideoKey: '',
        features: DefaultApplicationFeatures,
        flags:[]
    };
}




